import { Component, Input } from '@angular/core';
import {
  QuickAccessIconView,
  resolveQuickAccessIcon,
} from 'src/app/core/helpers/ui/quick-access-icon';
import { QuickAccessIconSource } from 'src/app/core/interfaces/ui/quick-access.interface';

@Component({
  selector: 'shared-quick-access-icon',
  templateUrl: './quick-access-icon.component.html',
  styleUrl: './quick-access-icon.component.scss',
})
export class QuickAccessIconComponent {
  @Input() faClass: string = '';
  @Input({ required: true })
  set page(value: QuickAccessIconSource) {
    this.icon = resolveQuickAccessIcon(value);
  }

  public icon: QuickAccessIconView = { kind: 'svg', name: '' };

  public get faClasses(): string[] {
    if (this.icon.kind !== 'fa') return [];
    return this.faClass ? [this.icon.classes, this.faClass] : [this.icon.classes];
  }

  public get svgName(): string {
    return this.icon.kind === 'svg' ? this.icon.name : '';
  }
}
